// firebase.js
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_ORDER_KEY,
  authDomain: "orders-onlineshop.firebaseapp.com",
  projectId: "orders-onlineshop",
  storageBucket: "orders-onlineshop.firebasestorage.app",
  messagingSenderId: "973818519459",
  appId: process.env.REACT_APP_FIREBASE_ORDER_APP_ID,
  measurementId: "G-90NJWGHSZE"
};

// Check if the app is already initialized
const orderApp =
  getApps().find(app => app.name === 'ordersApp') ||
  initializeApp(firebaseConfig, 'ordersApp');

// console.log('Connected to Firebase project:', orderApp.name);

// const analytics = getAnalytics(orderApp);
const orderDb = getFirestore(orderApp);

export { orderDb };
